import script from "./CustomerByPhoneResolver.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerByPhoneResolver.vue?vue&type=script&setup=true&lang=js"

import "./CustomerByPhoneResolver.vue?vue&type=style&index=0&id=4e037362&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e037362"]])

export default __exports__